<template>
  <div class="c-app" style="background-color: #ffffff" v-if="uid !== null">
    <div style="z-index: 9999;" v-if="loading === false">
      <TheSidebar />
    </div>
    <div class="c-wrapper">
      <div v-if="loading === false" style="z-index: 1040;">
        <TheMenuHeader v-if="$route.name !== 'DineInHome' && !isShowHeader()" />
        <div class="dine-in-header" v-if="isShowHeader()">
          <div @click="backOneStep()">
            <img width="50px" src="/left-arrow.png" style="position: fixed;left: 0;top: 0;margin: 1cap;">
          </div>
          <h4>{{ headerName }}</h4>
        </div>
      </div>
      <main class="c-main">
        <div class="c-body">
          <CContainer>
            <transition name="fade">
              <div v-if="loading === true">
                <div class="lds-ripple">
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div v-else-if="loading === false">
                <div class="text-center" v-if="orderCompleted === true" style="margin-top: 200px">
                  <img src="/img/thanks.png" class="img-fluid" width="50%" alt="" />
                  <h4 class="mt-5 font-weight-bold">{{ $t('errorMessages.paymentSuccess') }}</h4>
                  <span class="text-description">{{ $t('errorDescriptions.paymentSuccess') }}</span><br>
                  <CButton v-if="isTracking() !== ''" @click="goToTracking()" color="success" class="mt-4">{{
                    $t('goToTracking') }}</CButton>
                  <div class="fixed-bottom p-2">
                    <span class="text-grey">Powered by</span><br>
                    <img src="/img/SilomPOS_logo.png" width="90px">
                  </div>
                </div>
                <div v-else>
                  <router-view></router-view>
                  <div class="modal fade" tabindex="-1" id="payment-pending-modal">
                    <div class="modal-dialog">
                      <div class="modal-content" style="background-color: unset;">
                        <div class="small-modal p-0" style="background-color: white;overflow: hidden;">
                          <div class="text-center p-4">
                            <img src="/img/paymentPending.png" width="60px">
                            <h4 class="mt-3 text-black">{{ $t('proceedPayment') }}</h4>
                            <span class="text-description " v-html="$t('proceedPaymentDesp')" />
                            <div class="d-flex pt-3">
                              <CButton @click="goToPaymentGateway()" class="btn-color-theme" block>
                                {{ $t('visitProceedPayment') }}</CButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </transition>
          </CContainer>
        </div>
      </main>
    </div>
  </div>
  <div v-else style="background-color: #ffffff" class="min-vh-100">
    <div class="text-center p-5">
      <img style="margin-top: 200px" src="/img/staff_assist.png" class="img-fluid" width="60%" alt="" />
      <h5 class="mt-5 font-weight-bold">
        ติดต่อพนักงานของเรา<br>เพื่อขอความช่วยเหลือ
      </h5>
      <span class="text-muted">Please contact our staff for assistance</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheSidebar from './TheSidebarOrder'
import TheMenuHeader from '../views/menu/NavBar'
import poscrm from '@/services/poscrm'
import '@/util/loader.css'

export default {
  components: {
    TheMenuHeader,
    TheSidebar,
  },
  data() {
    return {
      loading: false,
      orderCompleted: false,
      trackingURL: '',
      lastFetchTime: 0,
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  computed: {
    ...mapGetters(['shopLineOA']),
    uid() {

      return `${localStorage.getItem('uid')}` || 'null'
    },
    shopObjectId() {
      return `${localStorage.getItem('shopObjectId')}`
    },
    tableObjectId() {
      if (this.table) {
        return this.table.objectId
      } else {
        return ''
      }
    },
    shopName() {
      const name = localStorage.getItem('shopName') || ''
      return name
    },
    headerName() {
      return this.$t(this.$route.name)
    },
    shop() {
      return this.shopLineOA.find(
        (detail) => detail.objectId === this.shopObjectId
      )
    },
  },
  beforeCreate() {
    this.$store.dispatch('getShopLineOA')
    localStorage.setItem('mode', process.env.NODE_ENV)
    if (this.$route.name == 'DineInHome') {
      localStorage.clear()
      let uid = this.$route.query.uid
      localStorage.setItem('uid', uid)
    }
  },
  async created() {
    await this.getOrderShopSetting()
    await this.getReceiptTransaction()
  },
  methods: {
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {

        // ✅ ถ้าจ่ายเสร็จแล้ว ไม่ต้องยิงแล้ว
        if (this.orderCompleted) return

        const now = Date.now()

        // ✅ กันยิงถี่ (อย่างน้อย 2 วิ)
        if (now - this.lastFetchTime < 2000) return

        this.lastFetchTime = now

        console.log('กลับมา tab → refresh receipt')
        this.getReceiptTransaction()
      }
    },
    redirect() {
      if (this.shopLineOA.length === 0) {
        this.loading = true
      } else if (this.shopLineOA.length > 0) {
        this.loading = false
      }
    },
    async getOrderShopSetting() {
      const uid = `${localStorage.getItem('uid')}` || null
      const shopObjectId = `${localStorage.getItem('shopObjectId')}` || null

      let params = {
        shopObjectId: shopObjectId,
      }
      if (uid) {
        try {
          await poscrm({
            method: 'get',
            url: '/api/v2.1/' + uid + '/OrderShopSetting',
            params: params,
          }).then((res) => {
            let themeColor = res.data?.data[0]?.themeColor || '#29B46B'
            if (themeColor) {
              $(':root').css('--bg-color-theme', themeColor)
            } else {
              $(':root').css('--bg-color-theme', '#29B46B')
            }
          })
        } catch (error) {
          $(':root').css('--bg-color-theme', '#29B46B')
          throw new Error(error)
        }
      }
    },
    async getReceiptTransaction() {
      let receiptObjectId = localStorage.getItem('receiptObjectId') || null

      if (receiptObjectId != null) {
        await poscrm
          .get('/api/v1.1/' + this.uid + '/Receipt/data/' + receiptObjectId)
          .then((res) => {

            let document = {}
            document = res?.data?.data?.document || {}
            if (document != null && document) {
              const receiptStatus = document?.receiptStatus || ''
              switch (receiptStatus) {
                case 'V':
                  localStorage.clear()
                  sessionStorage.clear()
                  this.$router.push('/expired?errorCode=5003')
                  return;
                case 'T':
                  localStorage.clear()
                  sessionStorage.clear()
                  this.$router.push('/expired?errorCode=5002')
                  return;
                case 'A':
                  
                  this.orderCompleted = true
                  document.removeEventListener('visibilitychange', this.handleVisibilityChange)
                  localStorage.clear()
                  sessionStorage.clear()
                  return;
                case 'P':
                  if (this.$route.name !== 'DineInPaymentDetails' && this.$route.name !== 'DineInPaymentGatewayKBank') {
                    $('#payment-pending-modal').modal('show')
                  } else {
                    $('#payment-pending-modal').modal('hide')
                  }
                  return;
                default:
                  return
              }
            } else {
              localStorage.clear()
              sessionStorage.clear()
              this.$router.push('/texp?errorCode=-2001')
            }
          })
      } else {
        let uid = localStorage.getItem('uid')
        if (uid == null) {
          this.orderCompleted = true
          this.verifyReceiptStatus()
        }
      }
    },
    isShowHeader() {
      const hideHeader = ['DineInPaymentDetails']
      return hideHeader.includes(this.$route.name)
    },
    backOneStep() {
      if (this.$route.query.redirect == 'payment') {
        this.$router.push('/delivery/history')
      } else {
        this.$router.go(-1)
      }
    },
    verifyReceiptStatus() {
      const params = new URLSearchParams(window.location.search);
      this.trackingURL = params.get('tracking') || '';
    },
    goToTracking() {
      const params = new URLSearchParams(window.location.search);
      this.trackingURL = params.get('tracking') || '';
      window.location.href = this.trackingURL
    },
    isTracking() {
      const params = new URLSearchParams(window.location.search);
      let trackingURL = params.get('tracking') || '';
      return trackingURL
    },
    goToPaymentGateway() {
      const ghlEnabled = this.shop?.GHLMethodEnabled?.enabled === true;
      const kbankEnabled = this.shop?.enabledKPaymentGateway === true;
      const selectedGateway = this.orderShopSetting?.selectedGateway;

      if (ghlEnabled && kbankEnabled) {
        // Both enabled → decide based on selected gateway
        if (selectedGateway === 'KBANK') {
          this.$router.push('/dine-in/paymentgateway');
        } else {
          this.$router.push('/dine-in/payment/details');
        }
      } else if (kbankEnabled) {
        this.$router.push('/dine-in/paymentgateway');
      } else {
        // GHL only or fallback
        this.$router.push('/dine-in/payment/details');
      }

      $('#payment-pending-modal').modal('hide');
    },
  },
  watch: {
    shopLineOA() {
      this.redirect()
    },
    $route() {
      document.title = this.shopName + ' by SilomPOS'
      this.getReceiptTransaction()
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.dine-in-header {
  width: 100%;
  height: 60px;
  background-color: white;
  color: #3c4b64;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding-top: 8px;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
